import { Tooltip } from "antd";
import { Link } from "react-router-dom"
import i from '../../../translations/i'

const iconDelete = <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
    <path d="M3 7V17C3 18.1046 3.89543 19 5 19H13C14.1046 19 15 18.1046 15 17V7M11 8V15M7 8V15M1 4H5M5 4H13M5 4V3C5 1.89543 5.89543 1 7 1H11C12.1046 1 13 1.89543 13 3V4M13 4H17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

const iconEdit = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.228 9.8325C11.5209 9.53961 11.5209 9.06473 11.228 8.77184C10.9351 8.47895 10.4602 8.47895 10.1673 8.77184L11.228 9.8325ZM5.23525 13.7039C4.94236 13.9968 4.94236 14.4717 5.23525 14.7646C5.52814 15.0575 6.00302 15.0575 6.29591 14.7646L5.23525 13.7039ZM0.833496 13.3704L0.0834961 13.3704V13.3704H0.833496ZM0.833496 18.8704H1.5835H0.833496ZM18.8779 5.64542L18.3476 6.17575L18.8779 5.64542ZM14.3544 1.12192L14.8847 0.591592L14.3544 1.12192ZM6.83867 19.0797L6.30834 18.5493L6.83867 19.0797ZM18.8779 7.04042L19.4082 7.57075L18.8779 7.04042ZM0.92017 13.1612L0.38984 12.6308H0.38984L0.92017 13.1612ZM12.9594 1.12192L12.4291 0.591593V0.591593L12.9594 1.12192ZM10.1673 8.77184L5.23525 13.7039L6.29591 14.7646L11.228 9.8325L10.1673 8.77184ZM0.0834961 13.3704L0.0834962 18.8704H1.5835L1.5835 13.3704H0.0834961ZM6.62942 18.4163H1.12942V19.9163H6.62942V18.4163ZM19.4082 5.11509L14.8847 0.591592L13.8241 1.65225L18.3476 6.17575L19.4082 5.11509ZM7.369 19.61L17.1465 9.8325L16.0858 8.77184L6.30834 18.5493L7.369 19.61ZM17.1465 9.8325L19.4082 7.57075L18.3476 6.51009L16.0858 8.77184L17.1465 9.8325ZM1.4505 13.6915L11.228 3.914L10.1673 2.85334L0.38984 12.6308L1.4505 13.6915ZM11.228 3.914L13.4897 1.65225L12.4291 0.591593L10.1673 2.85334L11.228 3.914ZM17.1465 8.77184L11.228 2.85334L10.1673 3.914L16.0858 9.8325L17.1465 8.77184ZM0.0834962 18.8704C0.0834962 19.4481 0.55177 19.9163 1.12942 19.9163V18.4163C1.3802 18.4163 1.5835 18.6196 1.5835 18.8704H0.0834962ZM1.5835 13.3704C1.5835 13.4908 1.53566 13.6063 1.4505 13.6915L0.38984 12.6308C0.193689 12.827 0.0834965 13.093 0.0834961 13.3704L1.5835 13.3704ZM18.3476 6.17575C18.4399 6.26808 18.4399 6.41777 18.3476 6.51009L19.4082 7.57075C20.0864 6.89264 20.0864 5.7932 19.4082 5.11509L18.3476 6.17575ZM6.62942 19.9163C6.90683 19.9163 7.17286 19.8061 7.369 19.61L6.30834 18.5493C6.39349 18.4642 6.50899 18.4163 6.62942 18.4163V19.9163ZM14.8847 0.591592C14.2066 -0.0865208 13.1072 -0.08652 12.4291 0.591593L13.4897 1.65225C13.5821 1.55993 13.7318 1.55993 13.8241 1.65225L14.8847 0.591592Z"/>
</svg>

const ButtonActionDelete = ({ item }) => {
    return(
        <>
            <button
                onClick={() => item.onClick()}
                className="button-action delete"
            >
                { iconDelete }
            </button>
        </>
    )
}

const ButtonActionEdit = ({ item }) => {
    return(
        <>
            <Link
                to={item.url}
                className="button-action edit"
            >
                { iconEdit }
            </Link>
        </>
    )
}


const ButtonAction = ({ item }) => {
    return(
        <Tooltip title={ item.placeholder }>
            {item.type === "delete" && <ButtonActionDelete item={item} />}
            {item.type === "statistics" && <Link
                to={item.url}
                className="button-action edit"
            >
                {i.t('promo:statistic')}
            </Link>}
            {item.type === "edit" && <ButtonActionEdit item={item} />}
        </Tooltip>
    )
}

export default ButtonAction